import axios from "axios";
import { removerSessaoAtiva } from "../util/libLocalStorage";

// const baseURL = "https://api.szsistemas.com.br:211";
// const baseURL = "http://localhost:11120";

const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL || "http://localhost:11120",
});

//intercepta o request depois dele acontecer
api.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		// se não tem o response
		if (!error.response) {
			error = {
				message:
					"Não foi possível encontrar o servidor. Por favor, verifique sua conexão com a internet e tente novamente.",
				status: 0,
			};
		} else if (error.response.status === 401) {
			removerSessaoAtiva();
			document.location = "/login"; //redireciona para o login
			error = {
				message: error.response.data,
				status: error.response.status,
			};
		} else if (isHTML(error.response.data)) {
			error = {
				message: error.message + " " + error.code,
				status: error.response.status,
			};
		} else {
			// Verifica se existe o campo errorJson
			if (error.response.data.errorJson) {
				// Se for um JSON, trata de forma diferente

				const message = error.response.data.errorJson;
				const field = error.response.data.field;
				const statusCode = error.response.status;

				error = { message, field: field, statusCode };
			} else {
				// Se não for um JSON válido, trata como antes
				error = {
					message: error.response.data,
					status: error.response.status,
				};
			}
		}
		throw error;
	},
);

// Função para verificar se a resposta é HTML
function isHTML(str) {
	const htmlRegex = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/;
	return htmlRegex.test(str);
}

export default api;
